import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';
import { Theater, Mic, Music, Star, Users, Award, Check, Clock } from 'lucide-react';

const FEATURES = [
  { icon: Theater, text: "Professional West End Training" },
  { icon: Mic, text: "Singing, Acting & Dancing" },
  { icon: Music, text: "Learn from Industry Professionals" },
  { icon: Star, text: "End of Week Showcase" },
  { icon: Users, text: "Make Lifelong Friends" },
  { icon: Award, text: "Certificate of Achievement" }
];

const WHAT_TO_BRING = [
  "Comfortable dance clothes",
  "Jazz/Dance shoes (or clean trainers)",
  "Water bottle",
  "Packed lunch & snacks",
  "Hair tied back",
  "Enthusiasm!"
];

const SCHEDULE = [
  { time: "9:00 AM", activity: "Warm-up & Stretching" },
  { time: "9:30 AM", activity: "Dance Session" },
  { time: "11:00 AM", activity: "Break" },
  { time: "11:15 AM", activity: "Singing Masterclass" },
  { time: "12:30 PM", activity: "Lunch" },
  { time: "1:30 PM", activity: "Acting Workshop" },
  { time: "3:00 PM", activity: "Break" },
  { time: "3:15 PM", activity: "Showcase Rehearsal" },
  { time: "4:00 PM", activity: "End of Day" }
];

const BootcampFeatures = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-black via-purple-950/20 to-black">
      <div className="container mx-auto px-4">
        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {FEATURES.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="bg-neutral-900/50 border-neutral-800 hover:border-purple-500/50 transition-all">
                  <CardContent className="p-6 flex items-center gap-4">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <span className="text-white font-medium">{feature.text}</span>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>

        {/* Schedule & What to Bring */}
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Daily Schedule */}
          <Card className="bg-neutral-900/50 border-neutral-800">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
                <Clock className="w-6 h-6 text-purple-400" />
                Daily Schedule
              </h3>
              <div className="space-y-3">
                {SCHEDULE.map((item, index) => (
                  <div 
                    key={index}
                    className="flex items-center gap-4 text-white/80"
                  >
                    <span className="w-20 text-purple-400 font-mono text-sm">{item.time}</span>
                    <span>{item.activity}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* What to Bring */}
          <Card className="bg-neutral-900/50 border-neutral-800">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6">What to Bring</h3>
              <div className="space-y-3">
                {WHAT_TO_BRING.map((item, index) => (
                  <div 
                    key={index}
                    className="flex items-center gap-3 text-white/80"
                  >
                    <Check className="w-5 h-5 text-green-400" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default BootcampFeatures;
